import React from "react";

/**
 * @param {{ question: string, answer: string }[]} props.items
 * @param {string} [props.heading] - visible H2
 */
export default function PageFaq({ items, heading = "FAQ" }) {
  return (
    <section className="mt-14 max-w-3xl" aria-labelledby="page-faq-heading">
      <h2 id="page-faq-heading" className="font-sans font-semibold text-2xl text-forest">
        {heading}
      </h2>
      <div className="mt-6 space-y-3">
        {items.map((f) => (
          <details
            key={f.question}
            className="group rounded-2xl border border-cream bg-white px-5 py-4 open:shadow-soft transition"
          >
            <summary className="font-sans font-medium text-base text-forest cursor-pointer list-none flex items-center justify-between gap-3 leading-snug">
              <span>{f.question}</span>
              <span className="text-gold text-xs group-open:rotate-180 transition shrink-0">▼</span>
            </summary>
            <p className="mt-3 text-sm text-botanical/85 leading-relaxed border-t border-cream/80 pt-3">{f.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
